<template>
    <v-layout>
        <v-flex pb-3
                data-qe-id="return_to_activity_feed_btn"
                class="return-to-activity-feed"
                @click="goToActivityFeed">
                <v-icon class="fas fa-caret-left">
                </v-icon>
            <span v-if="title">{{title}}</span>
            <span v-else>{{communityCommonConstant.MAIN}} {{communityName}} {{communityCommonConstant.CONVERSATION}}</span>
        </v-flex>
    </v-layout>
</template>

<script>
    import { communityCommonConstant } from '../communityCommon.constant';
    import { mapGetters } from "vuex";
    import { storeGetters } from "../../../store/storeGetters.constant";

    export default {
        name: 'ReturnToActivityFeed',
        data: () => ({
            communityCommonConstant,
        }),
        props: {
            title: {
                type: String,
            },
        },
        methods: {
            goToActivityFeed() {
                const routeName = this.$route.name && this.$route.name.toLowerCase();
                const communityIdRoute = this.$route.params.communityId;
                this.$router.push({
                    name: routeName,
                    params: {
                        communityId: communityIdRoute,
                    },
                });
            },
        },
        computed: {
            ...mapGetters({
                usersCommunitiesList: `chapter/${storeGetters.usersCommunitiesList}`,
            }),
            communityName() {
                let community = '';
                if (this.usersCommunitiesList) {
                    community = this.usersCommunitiesList.find(x => x.communityId === this.$route.params.communityId);
                }
                return community ? community.name : '';
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import "../../../common/styles/_colors.scss";

    .return-to-activity-feed {
        color: $ypo-cta;
        background-color: transparent;
        cursor: pointer;
        display: flex;
        font-weight: 600;

        i {
            color: $ypo-cta !important;
            font-size: 18px;
            padding: 2px 5px 0 0;
        }
    }
</style>
